import styled from 'styled-components';

export const FormWrapper = styled.div`
  padding: 0;
  flex-grow: 1;
`;

export const ContractWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  min-height: 350px;
  height: 100%;
  & > :first-child {
    height: 100%;
    flex-grow: 1;
    min-height: 350px;
  }

  & > * > iframe {
    height: 100%;
    flex-grow: 1;
    min-height: 350px;
  }
`;
